import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { BaseComponent } from './base.component';
import { BaseDirective } from './base.directive';

// Layout related
import {
    EuiAppModule,
    EuiPageModule,
    EuiNotificationsModule,
    EuiToolbarModule,
    EuiHeaderModule,
    EuiFooterModule,
    EuiBreadcrumbModule,
    EuiLanguageSelectorModule,
    EuiSearchModule,
    EuiUserProfileModule,
    EuiSidebarToggleModule,
    EuiSidebarMenuModule,
    EuiOverlayModule,
    EuiDimmerModule,
} from './layout';

import {
    EuiBadgeModule,
    EuiIconModule,
    EuiIconColorModule,
    EuiIconSvgModule,
    EuiLabelModule,
    EuiIconToggleComponentModule,

    EuiAlertModule,
    EuiAutocompleteModule,
    EuiBlockDocumentComponentModule,
    EuiBlockContentComponentModule,
    EuiButtonModule,
    EuiButtonsModule,
    EuiCardModule,
    EuiChipModule,
    EuiChipListModule,
    EuiDashboardButtonModule,
    EuiDashboardCardModule,
    EuiDropdownModule,
    EuiDialogModule,
    EuiGrowlComponentModule,
    EuiSlideToggleModule,
    EuiTabsModule,
    EuiMenuModule,
    EuiListModule,
    EuiTableModule,
    EuiFileUploadModule,
    EuiDateRangeSelectorModule,
    EuiPickerModule,
    EuiInputNumberDirectiveModule,
    EuiInputCheckboxModule,
    EuiSelectModule,
    EuiInputRadioModule,
    EuiPopoverModule,
    EuiMessageBoxModule,
    EuiInputTextModule,
    EuiTextAreaModule,
    EuiInputGroupModule,
    EuiFeedbackMessageModule,
    EuiTimepickerComponentModule,
} from './components';

// Directives
import {
    EuiMaxLengthDirectiveModule,
    EuiTemplateDirectiveModule,
    EuiTooltipDirectiveModule,
} from './directives';

// Pipes
import {
    EuiTruncatePipeModule,
} from './pipes';

const MODULES = [
    EuiAppModule,

    EuiPageModule,
    EuiNotificationsModule,
    EuiToolbarModule,
    EuiHeaderModule,
    EuiFooterModule,
    EuiOverlayModule,
    EuiDimmerModule,
    EuiBreadcrumbModule,
    EuiLanguageSelectorModule,
    EuiSearchModule,
    EuiUserProfileModule,
    EuiSidebarToggleModule,
    EuiSidebarMenuModule,

    EuiBadgeModule,
    EuiIconModule,
    EuiIconColorModule,
    EuiIconSvgModule,
    EuiLabelModule,
    EuiIconToggleComponentModule,

    EuiAlertModule,
    EuiAutocompleteModule,
    EuiBlockDocumentComponentModule,
    EuiBlockContentComponentModule,
    EuiButtonModule,
    EuiButtonsModule,
    EuiCardModule,
    EuiChipModule,
    EuiChipListModule,
    EuiDashboardButtonModule,
    EuiDashboardCardModule,
    EuiDateRangeSelectorModule,
    EuiDropdownModule,
    EuiDialogModule,
    EuiGrowlComponentModule,
    EuiSlideToggleModule,
    EuiTabsModule,
    EuiMenuModule,
    EuiListModule,
    EuiTableModule,
    EuiFileUploadModule,
    EuiPickerModule,
    EuiPopoverModule,
    EuiMessageBoxModule,
    EuiFeedbackMessageModule,
    EuiTimepickerComponentModule,

    EuiTemplateDirectiveModule,
    EuiTooltipDirectiveModule,
    EuiInputNumberDirectiveModule,
    EuiMaxLengthDirectiveModule,
    EuiInputCheckboxModule,
    EuiSelectModule,
    EuiInputRadioModule,
    EuiInputTextModule,
    EuiTextAreaModule,
    EuiInputGroupModule,

    EuiTruncatePipeModule,
];

@NgModule({
    imports: [
        CommonModule, RouterModule, ReactiveFormsModule, FormsModule,
        ...MODULES,
    ],
    declarations: [
        BaseComponent,
        BaseDirective,
    ],
    exports: [
        ...MODULES,
    ],
})
export class EuiAllModule { }
